import { useCallback, useRef } from 'react';
import type { ColumnRowGroupChangedEvent, ColumnState } from 'ag-grid-community';

export const useSortOnColumnRowGroupChanged = (defaultGroupColumns: string[]) => {
  const prevGroups = useRef(defaultGroupColumns.toString());

  const onColumnRowGroupChanged = useCallback((event: ColumnRowGroupChangedEvent) => {
    const eventColumnIds = event.columns?.map(col => col.getColId())?.toString() || '';

    if (prevGroups.current === eventColumnIds) {
      return;
    }

    if (event.columns?.length) {
      const excludeList: string[] = [];
      event.columns.forEach(col => {
        excludeList.push(col.getColId());
      });

      event.api.applyColumnState({
        state: event.columns.map(col => ({
          colId: col.getColId(),
          sort: 'asc',
        })),
        applyOrder: true,
      });

      const colStates = event.api.getColumnState();
      colStates.forEach((col: ColumnState) => {
        if (!excludeList.includes(col.colId!)) {
          col.sort = null;
        }
      });

      event.api.applyColumnState({
        state: colStates,
        applyOrder: true,
      });
    }
    prevGroups.current = eventColumnIds;
  }, []);

  return {
    onColumnRowGroupChanged,
  };
};
